<template>
  <div id="app">
    <!-- <Header /> -->
    <main>
      <b-container fluid>
        <PaymentFailed v-if="!user.adminUser && showSidebar" />
        <b-row>
          <b-col
            class="d-print-none"
            cols="12"
            md="8"
            lg="3"
            order="2"
            order-lg="1"
            order-xl="1"
            v-if="showSidebar"
            style="padding:0;"
          >
            <ProfileMenuNew v-if="Object.entries(user).length > 0" />
          </b-col>
          <b-col
            cols="12"
            md="12"
            lg="9"
            order="1"
            order-lg="2"
            order-xl="2"
            style="padding:0;"
          >
            <router-view />
          </b-col>
        </b-row>
      </b-container>
    </main>
  </div>
</template>
<script>
import ProfileMenuNew from '@/components/ProfileMenuNew';
import PaymentFailed from '@/components/PaymentFailed.vue';

export default {
  components: {
    ProfileMenuNew,
    PaymentFailed,
  },
  data() {
    return {
      showSidebar: true,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        const pages = ['feedback', 'app', 'login', 'forgot-password'];

        if (
          pages.includes(to.path.split('/')[1])
            ? (this.showSidebar = false)
            : (this.showSidebar = true)
        );
      },
    },
  },
  metaInfo: {
    title: '',
    titleTemplate: '%s | Servicestart',
  },
};
</script>
